import { Box, Button, Typography } from "@mui/material";
import { ModalDialog } from "components";
import { FC, useEffect, useState } from "react";

interface ModalMaintenanceNotificationProps {
  open: boolean;
  setOpen(value: boolean): void;
}

const ModalMaintenanceNotification: FC<ModalMaintenanceNotificationProps> = ({ open, setOpen }) => {
  const [button, setButton] = useState(false);

  const next = async () => {
    if (!button) return;

    setOpen(false);
    window.localStorage.setItem("modalMaintenanceNotification_holidays2025", "false");
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setButton(true);
    }, 5000);

    return () => {
      clearTimeout(timeout);
    };
  });

  return (
    <ModalDialog open={open} setOpen={next}>
      <Box justifyContent="center" alignItems="center" textAlign="center" p={4}>
        <Typography
          fontFamily="Montserrat"
          fontWeight={600}
          fontSize="15px"
          lineHeight="18px"
        >
          <span style={{ color: "#BE1717" }}>aviso!</span>
          <br />
          <br />
          estaremos fechados nos dias 25/12, 31/12 e 01/01.
          <br />
          <br />
          <span style={{ color: "#BE1717" }}>adiante o seu pedido para não ficar sem!</span>
        </Typography>
        <Box mt={3} display="flex" justifyContent="center">
          <Button
            variant="contained"
            onClick={next}
            disabled={!button}
            style={{ opacity: button ? 1 : 0 }}
          >
            entendi!
          </Button>
        </Box>
      </Box>
    </ModalDialog>
  );
};

export default ModalMaintenanceNotification;
